import { render, staticRenderFns } from "./OferteClient.vue?vue&type=template&id=76d6999b"
import script from "./OferteClient.vue?vue&type=script&lang=js"
export * from "./OferteClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports